/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const PlaceIcon = props => {
	const { color = '' } = props
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 9.399 12.531'>
			<path
				data-name='Icon awesome-map-marker-alt'
				d='M4.216 12.279C.66 7.123 0 6.594 0 4.7a4.7 4.7 0 019.4 0c0 1.895-.66 2.424-4.216 7.579a.588.588 0 01-.966 0zM4.7 6.657A1.958 1.958 0 102.741 4.7 1.958 1.958 0 004.7 6.657z'
				fill={color}
			/>
		</svg>
	)
}

export default PlaceIcon
